// import DeleteIcon from "assets/icons/DeleteIcon";
import Recommendation from "assets/icons/Recommendation";
// import Loader from "components/Loader";
import OutlinedButton from "components/common/Button/OutlinedButton";
import Label from "components/common/Label";
import { useModal } from "context/hooks/useModal";
// import { useRemovePersonalAI } from "hooks/personalai";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import defaultRecommendationImage from "assets/images/persona-ai/test-1.png"

export default function RecomendationCard({
  title,
  match,
  // type,
  date,
  image = defaultRecommendationImage,
  isLoading = false,
  // id,
  aiResponse,
}) {
  const { dir, language } = useAppSelector(getSettings);
  // const { mutate, isLoading: deletingRecommendation } = useRemovePersonalAI();
  const { showModal } = useModal();
  const { t } = useTranslation();

  return (
    <>
      <div
        className="max-w-max min-w-[185px] md:max-w-[240px] w-full md:min-w-[220px] rounded-xl shadow-md bg-white relative"
        dir={dir}
        onClick={() => {
          showModal(
            <div>
              <h3 className="text-theme-blue text-xl text-bold">
                {title[language]}
              </h3>
              <p dir={dir} lang={language} className="text-sm" dangerouslySetInnerHTML={{
                __html: aiResponse
              }}>
              </p>
              <p dir={dir} lang={language} className="text-sm mt-2 text-gray-400 italic">
                {t("aiRecommendationDisclamier")}
              </p>
            </div>,
            "sm"
          );
        }}
      >
        {/* <Loader type="block" open={deletingRecommendation} /> */}
        <div
          className="relative w-fll max-h-44 h-44 rounded-tr-xl rounded-tl-xl bg-center bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url(${image})`,
          }}
        ></div>
        <div className="p-3">
          <Label
            className="text-lg font-semibold line-clamp-1 text-theme-blue"
            title={title[language]}
          >
            {title[language]}
          </Label>
          <div className="flex flex-col gap-1 mt-1">
            <p className="text-[##1F1A20]" dir={dir}>
              {isLoading ? t("calculating") : `${match}% ${t("match")}`}
            </p>
            {/* <p className="text-[##1F1A20]">{type}</p> */}
            <p className="text-[##1F1A20]">
              {new Date(date).toLocaleDateString('en-GB')}
            </p>
            <div className="flex items-center justify-between box-border gap-3">
              <OutlinedButton
                className="rounded-md text-white bg-theme-yellow border-none w-fit px-4"
                onClick={() => {
                  showModal(
                    <div>
                      <h3 className="text-theme-blue text-xl text-bold">
                        {title[language]}
                      </h3>
                      <p dir={dir} lang={language} className="text-sm">
                        {aiResponse}
                      </p>
                    </div>,
                    "sm"
                  );
                }}
              >
                <Recommendation />
                <>{t("recommendation")}</>
              </OutlinedButton>
              {/* <DeleteIcon
                className="cursor-pointer min-w-[14px]"
                onClick={(e) => {
                  e.stopPropagation();
                  mutate(id);
                }}
              /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
